export const useLoginModalStore = defineStore('loginModal', {
  state: () => ({
    visible: false,
    callback: null,
  }),

  actions: {
    showModal(callback = null) {
      this.visible = true;
      this.callback = callback;
    },

    hideModal() {
      this.visible = false;
      this.callback = null;
    },

    executeCallback() {
      if (typeof this.callback === 'function') {
        this.callback();
      }
      this.hideModal();
    },
  },
});
